import { useState } from "react";
import AnimatedCoin from "./AnimatedCoin";
import AnimatedDice from "./AnimatedDice";

// We'll unify the aggregator logic + the animated coin/dice here
export default function CoinDiceSimulator() {
  // aggregator states
  const [coinFlips, setCoinFlips] = useState([]);
  const [diceRolls, setDiceRolls] = useState([]);

  // for each face 1..6
  function faceCount(n) {
    return diceRolls.filter(x => x === n).length;
  }

  // heads/tails stats
  const headsCount = coinFlips.filter(x => x === "Heads").length;
  const tailsCount = coinFlips.length - headsCount;

  // Now we maintain states to control animations
  const [coinIsFlipping, setCoinIsFlipping] = useState(false);
  const [coinOutcome, setCoinOutcome] = useState(null);

  const [diceIsRolling, setDiceIsRolling] = useState(false);
  const [diceOutcome, setDiceOutcome] = useState(null);

  // --- Called by <AnimatedCoin> when flipping is done
  function handleCoinDone(outcome) {
    // outcome is "Heads" or "Tails"
    setCoinOutcome(outcome);
    setCoinFlips(prev => [...prev, outcome]);
    setCoinIsFlipping(false);
  }

  // --- Called by <AnimatedDice> when rolling is done
  function handleDiceDone(face) {
    setDiceOutcome(face);
    setDiceRolls(prev => [...prev, face]);
    setDiceIsRolling(false);
  }

  return (
    <div style={{ border: "1px solid #ccc", padding: 10 }}>
      <h3>Coin & Dice Simulator (with Animation)</h3>

      {/* ============== COIN SECTION ============== */}
      <div style={{ marginBottom: "20px" }}>
        <h4>Flip Coin</h4>
        {/* We embed AnimatedCoin. We'll pass in props to control flipping. */}
        <AnimatedCoin
          isFlipping={coinIsFlipping}
          onDone={handleCoinDone}
        />

        <p>
          Total flips: {coinFlips.length} <br />
          Heads: {headsCount}, Tails: {tailsCount}
        </p>

        <button
        className="button1"
          onClick={() => {
            // start flipping
            setCoinIsFlipping(true);
            setCoinOutcome(null);
          }}
          disabled={coinIsFlipping}
        >
          {coinIsFlipping ? "Flipping..." : "Flip Coin"}
        </button>
        {coinOutcome && <p>Last Flip Result: {coinOutcome}</p>}
      </div>

      {/* ============== DICE SECTION ============== */}
      <div>
        <h4>Roll Dice</h4>
        {/* We embed AnimatedDice. We'll pass in props to control rolling. */}
        <AnimatedDice
          isRolling={diceIsRolling}
          onDone={handleDiceDone}
        />

        <p>Total rolls: {diceRolls.length}</p>
        <p>
          Face 1: {faceCount(1)} Face 2: {faceCount(2)} Face 3: {faceCount(3)}
          Face 4: {faceCount(4)} Face 5: {faceCount(5)} Face 6: {faceCount(6)}
        </p>

        <button
        className="button1"
          onClick={() => {
            setDiceIsRolling(true);
            setDiceOutcome(null);
          }}
          disabled={diceIsRolling}
        >
          {diceIsRolling ? "Rolling..." : "Roll Dice"}
        </button>
        {diceOutcome && <p>Last Roll Result: {diceOutcome}</p>}
      </div>
    </div>
  );
}
